import { io, Socket } from "socket.io-client";
import { resolveSocketUrl } from "./resolve-socket-url";

const create: () => Socket = (): Socket => {
  const url = resolveSocketUrl();
  const socket = io(url, {
    transports: ["websocket", "polling"],
    autoConnect: true,
  });
  socket.on("connect", () => {
    console.log(`[Socket] connected to ${url}`);
  });
  socket.on("disconnect", () => {
    console.log(`[Socket] disconnected from ${url}`);
  });
  return socket;
};

export { create };
